import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";

// TooltipProvider does NOT mount here (perf-route-splitting, docs/TASK.md eager-graph finding):
// the only Tooltip consumer in the app is components/ui/sidebar.tsx, reachable only from
// src/routes/_authenticated.tsx's AppShell — the root route renders for /sign-in too, and
// @base-ui/react's tooltip primitive (105 kB) has no reason to be in that cold visitor's eager
// graph. It's provided one layer down, in _authenticated.tsx, next to the other authenticated-
// only context (ApiClientProvider). Toaster stays here: CRAFT §5 mandates exactly one app-wide
// instance, and sonner carries none of tooltip's weight.
export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}
